<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">{{ date.format('YYYY-MM-DD') }} {{ room.name }} の予約時間を選択</div>
      <div class="card-body">
        <ul>
          <li>
            <div class="d-inline-flex">
              <div>
                ご利用可能な時間帯は
                <template v-for="programSchedule in programSchedules">
                  <template v-if="programSchedule.program_id === programId">
                    {{ momentFromHour(programSchedule["start_time"], date).format('HH:mm') }}-{{ momentFromHour(programSchedule["end_time"], date).format('HH:mm') }}
                  </template>
                </template>
                となります。
              </div>
            </div>
          </li>
          <li v-if="reserveMinutesList.length === 1">{{ room.name }}のご利用時間は1回あたり{{ reserveMinutesList.join("・") }}分となります。</li>
          <li v-else>{{ room.name }}のご利用時間は{{ reserveMinutesList.join("・") }}分の中からお選びいただけます。</li>

          <!-- ルームごとの1日あたりの利用回数の制限 -->
          <!--
          <li v-if="reservableTimesPerDayRoom">
            1日に{{ reservableTimesPerDayRoom }}回までのご利用となります。
          </li>
          -->

          <!-- ルームごとの予約件数の制限 -->
          <!--
          <li v-if="reservableTimesPerRoom === 1">
            同時に複数の予約を行うことはできません。
          </li>
          <li v-else-if="reservableTimesPerRoom > 1">
            同時に{{ reservableTimesPerRoom }}件まで予約できます。
          </li>
          -->
        </ul>

        <!-- プログラムが2つ以上あるルームであればセレクタを表示 -->
        <div v-if="room['programs'].length >= 2">
          <div class="btn-group-toggle flex-wrap">
            <template v-for="program in room['programs']">
              <label class="btn btn-success mr-1 mb-1" :class="{'active' : (programId === program['id'])}">
                <input v-model="programId" type="radio" :value="program.id">{{ program.name }}を予約
              </label>
            </template>
          </div>
        </div>

        <!-- 複数の予約時間があるプログラムであればセレクタを表示 -->
        <div v-if="reserveMinutesList.length >= 2">
          <div class="btn-group-toggle flex-wrap">
            <label v-for="reserveMinutesCurrent in reserveMinutesList" class="btn btn-success mr-1 mb-1 p-1 p-sm-2" :class="{'active' : (reserveMinutes === reserveMinutesCurrent)}">
              <input v-model="reserveMinutes" :value="reserveMinutesCurrent" type="radio">{{ reserveMinutesCurrent }}分
              <span class="text-nowrap">{{ $config.program_reservation_minutes_price[programId][reserveMinutesCurrent].toLocaleString() }}円</span>
            </label>
          </div>
        </div>

        <template v-for="program in room['programs']">
          <div v-if="programId === program['id']" class="mt-3">
            <ul class="list-group">
              <template v-for="programSchedule in programSchedules">
                <template v-if="programSchedule['program_id'] === program['id']">
                  <li class="list-group-item text-center bg-dark text-white">
                    {{ program.name }}
                    {{ momentFromHour(programSchedule["start_time"], date).format('HH:mm') }}
                    -
                    {{ momentFromHour(programSchedule["end_time"], date).format('HH:mm') }}
                  </li>
                  <template v-if="program.id in reservablePeriods">
                    <template
                        v-for="reserveListHourChunked in reserveList(program, programSchedule.start_time, programSchedule.end_time)"
                    >
                      <!-- 1時間ごとリストのうち最初の開始時間をタイトルとして使う -->
                      <li class="list-group-item text-center" dusk="toggle-reserve-list" @click="toggleReserveList(reserveListHourChunked.start)">
                        <div class="lead font-weight-bold  text-nowrap">
                          {{ reserveListHourChunked.start.format('HH:mm') }}～
                          <span class="toggle-button" v-if="isReserveListVisible(reserveListHourChunked.start)">▲</span>
                          <span class="toggle-button" v-else>▼</span>
                        </div>
                      </li>

                      <transition name="slide">
                        <div v-if="isReserveListVisible(reserveListHourChunked.start)">
                          <!-- 1時間ごとリストを表示 -->
                          <li
                              v-for="reserve in reserveListHourChunked.reserveList"
                              v-if="!reservableStartTime || reservableStartTime.includes(reserve.start.format('HH:mm'))"
                              class="list-group-item text-center"
                          >
                            <div class="lead font-weight-bold  text-nowrap">
                              {{ reserve.start.format('HH:mm') }}
                              -
                              {{ reserve.end.format('HH:mm') }}

                              <template v-if="!reserve.start.isBetween(reservableDatetimeNear, reservableDatetimeFar)">
                                <a class="btn btn-sm btn-dark mb-1 disabled">不可</a>
                              </template>
                              <template v-else-if="reserve.reservable">
                                <a @click.prevent="reserveSet(program,reserve.start,reserve.end)" class="btn btn-sm btn-success mb-1 text-white">予約</a>
                              </template>
                              <template v-else>
                                <a href="reserve_complete" class="btn btn-sm btn-danger mb-1 disabled">満員</a>
                              </template>
                            </div>
                          </li>
                        </div>
                      </transition>
                    </template>
                  </template>
                </template>
              </template>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* グループ開閉中アニメーション */
.slide-enter-active, .slide-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s;
  transform: translate(0px, 0px); /* 設定しないと初期値?のX=30pxが設定されて要素が横にずれる */
}

/* グループ閉状態 */
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* グループ開状態 */
.slide-enter-to, .slide-leave {
  max-height: 1000px; /* 開いた状態で十分な高さを指定 */
  opacity: 1;
  overflow: hidden;
}

.toggle-button {
  position: absolute;
  top: 50%;
  right: 15px;
  width: 30px;
  height: 20px;
  line-height: 1;
  margin-top: -10px;
  color: #38c172;
  transition: .3s;
}

</style>

<script>
export default {
  data() {
    return {
      member: {},
      roomId: parseInt(this.$route.params.roomId),
      date: this.moment(this.$route.params.date),
      programId: null,
      reserveMinutes: null,
      reserveMinutesList: [],
      reservableTimesPerDayRoom: this.$config['reservable_times_per_day_room'][this.$route.params.roomId],
      reservableTimesPerRoom: this.$config["reservable_times_per_room"][this.$route.params.roomId],
      intervalMinutes: 5,
      room: {
        'programs': []
      },
      programSchedules: [],
      reservablePeriods: {},
      reservableStartTime: null,
      // 予約可能な日時範囲
      reservableDatetimeNear: undefined,
      reservableDatetimeFar: undefined,
      // 時間ごと分割の表示・非表示
      reserveListShow: []
    }
  },
  async created() {
    this.$store.commit("loading/setLoading", true);

    // 戻りリンク先を設定
    this.$store.commit("backButton/setTo", "/member");

    // ルーム情報を取得
    await axios.get('/member/api/rooms/' + this.roomId)
        .then(response => {
          this.room = response.data.room;
          this.programId = this.room['programs'][0]['id']; // 初期選択プログラム
        })
        .catch(error => this.$store.state.error.code = error.response.status);

    // 予約分数
    let configReserveMinutes = this.$config["program_reservation_minutes"][this.programId];
    if (Array.isArray(configReserveMinutes)) {
      // 複数ある場合は先頭を初期値に設定
      this.reserveMinutes = configReserveMinutes[0];
      this.reserveMinutesList = configReserveMinutes;
    } else {
      this.reserveMinutes = configReserveMinutes;
      this.reserveMinutesList.push(configReserveMinutes);
    }

    await Promise.all([
      // メンバー情報を取得
      this.getMember(),
      // プログラムスケジュール情報を取得
      this.getProgramSchedules(),
      // 予約可能・不可能な時間帯のリストを取得
      this.getReservablePeriods(),
      // プラン・ルームごとの予約可能開始時間リストを取得
      this.getReservableStartTime(),
    ]);

    this.$store.commit("loading/setLoading", false);
  },
  methods: {
    // メンバー情報を取得
    async getMember() {
      await axios.get('/member/api/profile/')
          .then(response => this.member = response.data.member)
          .catch(error => this.$store.state.error.code = error.response.status);

      // ユーザごとの予約可能な日時範囲を取得
      this.reservableDatetimeNear = this.moment(this.member["plan"]["reservable_datetime_between"]["near_datetime"]);
      this.reservableDatetimeFar = this.moment(this.member["plan"]["reservable_datetime_between"]["far_datetime"]);
    },
    // プログラムスケジュール情報を取得
    async getProgramSchedules() {
      await axios.get('/member/api/program_schedules', {
        params: {
          'room_id': this.roomId,
          'date': this.date.format('YYYY-MM-DD'),
        }
      })
          .then(response => {
            this.programSchedules = response.data.program_schedules;
          })
          .catch(error => this.$store.state.error.code = error.response.status);

    },
    // 予約可能・不可能な時間帯のリストを取得
    async getReservablePeriods() {
      for (let program of this.room.programs) {
        await axios.get('/member/api/reservable_periods', {
          params: {
            'program_id': program.id,
            'date': this.date.format('YYYY-MM-DD'),
          }
        })
            .then(response => {
              this.$set(this.reservablePeriods, program.id, response.data.reservable_periods);
            })
            .catch(error => this.$store.state.error.code = error.response.status);
      }
    },
    // 利用プラン・ルームごとの予約可能開始時間リストを取得
    async getReservableStartTime() {
      await axios.get('/member/api/reservable_start_time', {
        params: {
          'room_id': this.roomId,
          'date': this.date.format('YYYY-MM-DD'),
        }
      })
          .then(response => {
            this.reservableStartTime = response.data.reservable_start_time;
          })
          .catch(error => this.$store.state.error.code = error.response.status);
    },
    // 予約可能期間内でインターバルごとに予約枠を生成する
    reserveList(program, start, end) {
      start = this.momentFromHour(start, this.date);
      end = this.momentFromHour(end, this.date).add(-1 * this.reserveMinutes, 'minutes');

      let reserveList = [];
      while (start.diff(end) <= 0) {
        // 予約が可能な時間かどうかチェックする
        let reservable = false;

        for (let reservablePeriod of this.reservablePeriods[program.id]) {
          let reservableStart = this.momentFromHour(reservablePeriod.start_time, this.date);
          let reservableEnd = this.momentFromHour(reservablePeriod.end_time, this.date);

          // 開始時間と終了時間が予約可能な時間帯の範囲内かどうか
          if (
              start.isBetween(reservableStart, reservableEnd, null, '[]')
              && start.clone().add(this.reserveMinutes, 'minutes').isBetween(reservableStart, reservableEnd, null, '[]')
          ) {
            reservable = true;
            break;
          }
        }

        reserveList.push({
          start: start.clone(),
          end: start.clone().add(this.reserveMinutes, 'minutes'),
          reservable: reservable,
        });

        start.add(this.intervalMinutes, 'minutes');
      }

      // リストを時間ごとに分割する
      let reserveListHourChunked = [];
      reserveList.forEach(function (reserve) {
        // スタート時間をキーとして利用する
        let startHour = reserve.start.format('HH:00');

        // この時間のキーを持つ値がない場合は新たに作成
        if (!reserveListHourChunked[startHour]) {
          reserveListHourChunked[startHour] = {
            "start": reserve.start,
            "reserveList": [],
          }
        }

        // オブジェクトに要素を追加
        reserveListHourChunked[startHour]["reserveList"].push(reserve);
      });

      // 値だけの配列をレスポンスする
      return Object.values(reserveListHourChunked);
    },

    // 指定した予約日時グループの有効状態を切り替える
    toggleReserveList(hour) {
      if (this.reserveListShow.includes(hour.format('HH:mm'))) {
        // すでに有効なリストに含まれていれば除外
        this.reserveListShow = this.reserveListShow.filter(h => h !== hour.format('HH:mm'));
      } else {
        // 有効なリストに含まれていなければ追加
        this.reserveListShow.push(hour.format('HH:mm'));
      }
    },

    // 時間ごとの予約リストの開閉状態を取得する
    isReserveListVisible(hour) {
      // 指定した予約日時が表示が有効なグループに含まれているかどうか
      return this.reserveListShow.includes(hour.format('HH:mm'));
    },

    // 予約の実行
    async reserveSet(program, start, end) {
      let msg = "以下の内容で予約を行います。よろしいですか?<br>";
      msg += this.room['name'] + "<br>";
      if (this.roomId === 1) {
        msg += program['name'] + "<br>";
      }
      msg += this.date.format('M月D日') + " ";
      msg += start.format('HH:mm') + '-' + end.format('HH:mm') + " ";
      msg += "(" + end.diff(start, 'minutes') + "分)";

      this.$dialog.confirm(msg).then(async () => {
        this.$store.commit("loading/setLoading", true);

        // 予約情報を保存
        await axios.post('/member/api/reservations', {
          program_id: program.id,
          start_datetime: start.format('YYYY-MM-DD HH:mm:ss'),
          end_datetime: end.format('YYYY-MM-DD HH:mm:ss'),
        })
            .then(response => {
              this.$toasted.show('予約しました');

              // 広告コンバージョンタグ実行用外部ページ呼び出しiframeを生成
              this.$store.commit("iframe/setUrl",
                  this.$config.app_url + "/ad/d-ap-cv.html"
                  + "?args=" + this.member.id
                  + "-" + response?.["data"]?.["reservation"]?.["id"]
              );
            })
            .catch((error) => {
                  const {data, status, statusText} = error.response;
                  if (status === 422) {
                    for (let msg of Object.values(data.errors).flat()) {
                      this.$toasted.show(msg, {type: 'error'});
                    }
                  } else {
                    this.$store.state.error.code = error.response.status;
                  }
                }
            );

        // 予約可能・不可能な時間帯のリストを再取得
        this.getReservablePeriods();

        this.$store.commit("loading/setLoading", false);
      });
    },
  }
};
</script>
